
import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import Spinner from 'react-bootstrap/Spinner';
import { isEmpty, get } from "lodash";
import { getEmployeeData, getEmployeeDataWithStatus, getInfoLTLedger, searchInfoLTLedger } from "./HRDetails.actions";
import { appendNonSignificantZeros } from '../../../../../global/globalFunctions';
import { baseURL, headers } from "../../../../../global/api";
import jsPDF from "jspdf";
import logo from "../../../../../Images/logo.png";
import Select from 'react-select';
import { Redirect, Link } from "react-router-dom";
import MaterialTable from "material-table";
import swal from "sweetalert";

const HRLTLedgerReport = (props) => {

  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  console.log(employeeId, 'employeeId');
  const [visibleAlert, setAlertVisible] = useState(false);

  const handleVisible = () => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    swal({
      title: "Warning",
      text: "No Data Found",
      icon: "info",
      button: "Ok",
    });
  };
  /* const [state, setState] = React.useState({
     columns: [
       { title: 'Account Name', field: 'acc_name' },
       { title: 'Account Type', field: 'acc_type' },
       { title: 'Opening Balance', field: 'opening_balance' },
       { title: 'Credit Value', field: 'credit_value' },
       { title: 'Debit Value', field: 'debit_value' },
       { title: 'Closing Balance', field: 'closing_balance' },
       { title: 'Date', field: 'long_term_ledger_date' }
     ],
   });*/

  // const getEmployeeList = !isEmpty(props.employeeList) ? props.employeeList.map((x) => { let data = { value: x.employeeId, label: `${x.employeeId} ${x.name}` }; return data }) : [];
  // !isEmpty(getEmployeeList) && getEmployeeList.push({ value: "All", label: "All" });

  const getEmployeeList = !isEmpty(props.activeEmployeeList) ? props.activeEmployeeList.map((x) => { let data = { 
value: x._id, label: `${appendNonSignificantZeros(x.employeeName)}-${x.fatherName}-${x.cnic}`
  }; return data }): [];
  // !isEmpty(getEmployeeList) && getEmployeeList.push({ value: "All", label: "All" });

  console.clear();
  console.log({getEmployeeList},props.activeEmployeeList)

  const handleChangeEmployee = (selectedOption) => {
    setEmployeeId(selectedOption.value);
    setShow(false)
  };
  const LTLedger = props.ltLedger;
  console.log(LTLedger, 'ledger');
  // const exportPDF = () => {
  //   props.searchAccountLedgerReport({
  //     startedDate: !isEmpty(startDate) ? startDate : "",
  //     endDate: !isEmpty(endDate) ? endDate : "",
  //     employeeId: employeeId,
  //   }, startDate, endDate);
  // }

  const clearStates = () => {
    setEmployeeId('');
    // setEndDate('');
    // setStartDate('');

  }
  useEffect(() => {
    props.getEmployeeData();
     props.getEmployeeDataWithStatus(1);
     setShow(false)
  }, []);

  function searchLedger() {
    props.searchInfoLTLedger({
      startedDate: !isEmpty(startDate) ? startDate : "",
      endDate: !isEmpty(endDate) ? endDate : "",
      employee_id: employeeId,
    })
    setShow(true)
  }
  function getLedger() {
    props.getInfoLTLedger({
      startedDate: !isEmpty(startDate) ? startDate : "",
      endDate: !isEmpty(endDate) ? endDate : "",
      employee_id: employeeId,
    },
    handleVisible);
    // clearStates();

  }


  return (
    <>
      {props.isFetchingEmployeeList ||props.isFetchingSearchLTLedger? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isFetchingSearchLTLedger ? 'Loading...' : 'Loading...'
            }

          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    <b> Start Date </b>

                  </Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(e) => setStartDate(e.target.value)}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col >
                <Form.Group>
                  <Form.Label>
                    <b> End Date</b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(e) => setEndDate(e.target.value)}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col >
                <Form.Group>
                  <Form.Label>
                    <b> Select Employee </b>
                  </Form.Label>
                  <Select
                  style={{ zIndex: 1 }}
                    placeholder="Select Employee..."
                    onChange={handleChangeEmployee}
                   
                    options={getEmployeeList}
                    isDisabled={isEmpty(getEmployeeList)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>

              <Col lg="12" sm="12" className="text-center" style={{marginTop:10}}>
                {employeeId == "" ?
                  <Button disabled >Search</Button> :
                  // <Link to= {{pathname : "/user/Ledger-List", 
                  // state: {start: startDate, end: endDate}}}>
                    <Button onClick={() => searchLedger()}>Search</Button>
                  // </Link>
                }
              </Col>
            </Row>

            <div className="sendDiv" style={{marginTop:'15px'}}>
              {employeeId =="" ?
                <Button disabled style={{ backgroundColor: "black" }} className="sendButton">Generate Ledger Report</Button> :
                <Button className="sendButton" onClick={() => getLedger()}>Generate Ledger Report</Button>}
            </div>
          {show&&  <MaterialTable
              title={`${isEmpty(props.searchltLedger.data)?"":props.searchltLedger.data[0].employee_id}-${isEmpty(props.searchltLedger.data)?"":props.searchltLedger.data[0].acc_name} (${isEmpty(props.searchltLedger.data)?"":props.searchltLedger.data[0].department}/${isEmpty(props.searchltLedger.data)?"":props.searchltLedger.data[0].designation}) LT Ledger`}
              columns={[
                // { title: 'Emloyee Id', field: 'employee_id' },
                // { title: 'Account Name', field: 'acc_name' },
                //  { title: 'Account Type', field: 'acc_type' },
                { title: 'Date', field: 'long_term_ledger_date' },
                { title: 'Description', field: 'long_term_description' },
                { title: 'Advance Given', field: 'credit_value' },
                { title: 'Advance Deduction', field: 'debit_value' },
                { title: 'Closing Balance', field: 'closing_balance' },
                
              ]}
              data={props.searchltLedger.data}
              //   data={
              //     // LTLedger
              //     (query) =>
              //     new Promise((resolve, reject) => {
              //         let url = `${baseURL}long_term_adv/get_lt_employee_ledger?`;
              //         url += "size=" + query.pageSize;
              //         url += "&page=" + (query.page + 1);
              //         url += "&search=" + query.search;
              //         fetch(url, {
              //             method: 'GET',
              //             headers: headers,
              //         })
              //             .then((response) => response.json())
              //             .then((result) => {
              //                 resolve({
              //                     data: result.data,
              //                     page: result.page - 1,
              //                     totalCount: result.total_results,
              //                 });
              //             });
              //     })
              //}
              options={{
                actionsColumnIndex: -1,
                filtering: false,
                exportButton: true,
                exportAllData: true,
                emptyRowsWhenPaging: false,
                exportPdf: (columns, data) => {
                  const doc = new jsPDF();
                  //render:rowData=>rowData.hall_name
                  const columnTitles = [
                    { title: 'Account Name', field: 'acc_name', render: rowData => rowData.acc_name },
                    // { title: 'Account Type', field: 'acc_type' },
                    { title: 'Description', field: 'long_term_description', render: rowData => rowData.long_term_description },
                    { title: 'Advance Given', field: 'credit_value', render: rowData => rowData.credit_value },
                    { title: 'Advance Deduction', field: 'debit_value', render: rowData => rowData.debit_value },
                    { title: 'Closing Balance', field: 'closing_balance', render: rowData => rowData.closing_balance },
                    { title: 'Date', field: 'long_term_ledger_date', render: rowData => rowData.long_term_ledger_date }
                  ]
                    .map(columnDef => columnDef.title);
                  const companyName = `${process.env.REACT_APP_COMPANY_NAME}`;
                  const companyAddress = `${process.env.REACT_APP_COMPANY_ADDRESS}`;
                  const companyNtn = `${process.env.REACT_APP_COMPANY_NTN}`;
                  const pdfData = data.map((rowData) => [rowData.acc_name, rowData.long_term_description, rowData.credit_value, rowData.debit_value, rowData.closing_balance, rowData.long_term_ledger_date]);
                  let content = {
                    startY: 50,
                    startX: 5,
                    head: [columnTitles],
                    body: pdfData
                  };
                  doc.addImage(logo, 'PNG', 10, 1, 40, 40);
                  doc.setFontSize(20);
                  doc.setFont(undefined, 'bold')
                  doc.text(companyName, 60, 22, 0, 0);
                  doc.setFontSize(13);
                  doc.setFont('TimesNewRoman', 'Normal')
                  doc.text(companyAddress, 60, 29, 0, 0);
                  doc.text(companyNtn, 60, 36, 0, 0);
                  doc.autoTable(content);
                  doc.save(`HRLT Ledger Table.pdf`);
                },
                headerStyle: {
                  position: 'sticky', top: 0,
                  color: '#00BBBB',
                  fontWeight: '550',
                  onRowAdd: 'none',
                },

              }}
            />}
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEmployeeData: () => dispatch(getEmployeeData()),
    getInfoLTLedger: (data,handleVisible) => dispatch(getInfoLTLedger(data,handleVisible)),
    searchInfoLTLedger: (data) => dispatch(searchInfoLTLedger(data)),
    // searchAccountLedger: (data) => dispatch(searchAccountLedger(data)),
    // searchAccountLedgerReport: (data, startDate, endDate) => dispatch(searchAccountLedgerReport(data, startDate, endDate)),
    getEmployeeDataWithStatus: (status) => dispatch(getEmployeeDataWithStatus(status)),

  };
};
const mapStateToProps = (state, ownProps) => ({
  employeeList: state.HrReducer.employeeList,
  isFetchingEmployeeData: state.HrReducer.isFetchingEmployeeData,
  ltLedger: state.HrReducer.ltLedger,
  isFetchingLTLedger: state.HrReducer.isFetchingLTLedger,
  searchltLedger: state.HrReducer.searchltLedger,
  isFetchingSearchLTLedger: state.HrReducer.isFetchingSearchLTLedger,
  level5LedgerData: state.AccountLegderReducer.level5LedgerData,
  searchAccountLedgerList: state.AccountLegderReducer.searchAccountLedgerList,
  isFetchingLevel5LedgerData: state.AccountLegderReducer.isFetchingLevel5LedgerData,
  isFetchingSearchAccountLedger: state.AccountLegderReducer.isFetchingSearchAccountLedger,

  activeEmployeeList: state.HrReducer.activeEmployeeList,
  isFetchingActiveEmployeeData: state.HrReducer.isFetchingActiveEmployeeData,

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HRLTLedgerReport);